import { useMediaQuery } from 'usehooks-ts';
import { ProcSubmitButton } from '@/entities/proc';
import { Row } from '@/shared/ui';
import { PageLayoutHeaderGoBackBtn } from '@/widgets/page-layout';

type Props = {
  canSubmit?: boolean;
};

export const ProcInstancePublicPageHeader = ({ canSubmit }: Props) => {
  const isMobileView = useMediaQuery('(max-width: 768px)');

  return (
    <Row justifyContent="space-between">
      <PageLayoutHeaderGoBackBtn navToPrevious />
      {canSubmit ? (
        <ProcSubmitButton />
      ) : (
        !isMobileView && (
          <img
            alt="Suresteps"
            src="https://suresteps-public.s3.amazonaws.com/wordmark.svg"
            style={{ height: 25 }}
          />
        )
      )}
    </Row>
  );
};
